import { useEffect } from 'react';

const RedirectToMennu = () => {
  useEffect(() => {
    window.location.href = 'https://mennu.mx';
  }, []);

  return null;
};

export default RedirectToMennu;




